import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @description Props for the ConfirmationButton component
 * @typedef {Object} ConfirmationButtonProps
 * @property {boolean} isValid - Determines if the button should be enabled or disabled
 * @property {MouseEventHandler} onClick - Function to handle click events on the button
 */
type ConfirmationButtonProps = {
  isValid: boolean;
  onClick: MouseEventHandler;
};

/**
 * @description Confirmation button component for the concentration form.
 * Enabled or disabled based on form validation state.
 *
 * @SADtrace SAD-003-4.1, SAD-003-4.2, SAD-003-4.3
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {ConfirmationButtonProps} props - Component props
 *
 * @returns {JSX.Element} Rendered component
 */
const ConfirmationButton: FC<ConfirmationButtonProps> = ({
  isValid,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-start pt-5">
      <a
        href="/#"
        className={`btn btn-lg rounded btn-primary ${
          isValid ? '' : 'disabled'
        }`}
        onClick={onClick}
        data-testid="confirm-button"
      >
        {t('buttons.confirm')}
      </a>
    </div>
  );
};

export default ConfirmationButton;
